import { useEffect, useState, useCallback } from "react";
import { jwtDecode } from "jwt-decode";

export const useAuthentication = () => {
  const storedUserData = JSON.parse(localStorage.getItem("logindata") || "{}");
  const initialToken = storedUserData?.data?.token || "";

  const [isAuthenticated, setIsAuthenticated] = useState(!!initialToken);
  const [token, setToken] = useState(initialToken);
  const [nombre, setNombre] = useState(null);
  const [role, setRole] = useState(null);

  const removeToken = useCallback(() => {
    localStorage.removeItem("logindata");
    setIsAuthenticated(false);
    setToken(null);
    setNombre(null);
    setRole(null);
  }, []);

  const decodeToken = useCallback(
    (tokenValue) => {
      try {
        const decoded = jwtDecode(tokenValue);
        const currentTime = Math.floor(Date.now() / 1000);

        if (decoded.exp && decoded.exp < currentTime) {
          removeToken();
          return;
        }

        setNombre(decoded.nombre || null);
        setRole(decoded.role || null);
      } catch (error) {
        console.error("Error decoding token:", error);
        removeToken();
      }
    },
    [removeToken]
  );

  const checkAuth = useCallback(() => {
    const data = JSON.parse(localStorage.getItem("logindata") || "{}");
    const tokenValue = data?.data?.token || "";

    if (!tokenValue) {
      removeToken();
      return;
    }

    setIsAuthenticated(true);
    setToken(tokenValue);
    decodeToken(tokenValue);
  }, [decodeToken, removeToken]);

  useEffect(() => {
    checkAuth();

    const handleAuthChange = () => checkAuth();

    window.addEventListener("storage", handleAuthChange);
    window.addEventListener("authChange", handleAuthChange);

    return () => {
      window.removeEventListener("storage", handleAuthChange);
      window.removeEventListener("authChange", handleAuthChange);
    };
  }, [checkAuth]);

  return { isAuthenticated, token, nombre, role };
};